import { creationFoundKeywordVideosService } from '@/services';

export const foundKeywordVideos = {
    namespaced: true,
    state: {
        all: [],
        loading: false
    },
    actions: {
        save({ commit }, payload) {
            commit('saveRequest');

            let videoRequestId = payload['videoRequestId'],
                foundKeywordId = payload['foundKeywordId'],
                videoHashUnique = payload['videoHashUnique']
            ;

            creationFoundKeywordVideosService.post({
                video_request_id: videoRequestId,
                found_keyword: foundKeywordId,
                video_hash_unique: videoHashUnique
                })
                .then(
                    data => commit('saveSuccess', data),
                    error => commit('saveFailure', error)
                );
        },
    },
    mutations: {
        saveRequest(state) {
            state.loading = true;
        },
        saveSuccess(state, response) {
            state.all = response.data.results;
            state.loading = false;
        },
        saveFailure(state) {
            alert('An error occurred your images are not saving, please stop now, and contact IT Support.');
            state.loading = false;
        },
    }
}
